import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { ActiveProfileService, IpsBaseWebService, SearchInfo, SearchResponse } from "imagine-ui-ng-core";
import { LocationFixtureModel } from "../../../imagine-ui-ng-store-profile";
import { environment } from "../../../../environments/environment";

@Injectable()
export class FixtureBySpaceService extends IpsBaseWebService {
    public SpaceId: string;
    private route: string;

    constructor(http: HttpClient, activeProfileService: ActiveProfileService) {
        super(http, <any>environment, activeProfileService);
        this.init("Fixture", "Profile", "v1");
        this.route = `${this.urlApiBaseProductPlusVersion}Space/{id}/Fixture`;
    }

    public headBySpace(id: string) {
        return this.headByRoute(this.route.replace("{id}", id));
    }
    // Override ipsBaseWebService.search method
    search<T>(searchInfo: SearchInfo, route: string): Promise<T> {
        return this.searchByRelation(searchInfo, "Space/" + searchInfo.id + "/Fixture/Search");
    }
}
